import { useEffect, useRef, useState } from 'react';
import { Customer } from 'types/common_types';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import { getCustomers, updateCustomer } from 'store/actions/customer-action';
import { useNavigate } from 'react-router-dom';

export default () => {
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const debounceTimer = useRef(null)

  const { customers, customer_loading } = useSelector((state: RootState) => state.customer);
  const { user } = useSelector((state: RootState) => state.common);

  const [selectedCustomer, setSelectedCustomer] = useState<Customer | null>(null);
  const [deactivateModal, setDeactivateModal] = useState<boolean>(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const pageSize = 20;

  useEffect(() => {
    dispatch(getCustomers({ pageSize, pageNumber: page }));
  }, []);

  const onPageChange = (newPage: number = page) => {
    setPage(newPage);
    dispatch(getCustomers({ pageSize, pageNumber: newPage }));
  };

  const handleCreate = () => {
    navigate('/manage-customer', { state: { mode: 'create' } });
  };

  const handleEdit = (customer: Customer) => {
    navigate('/manage-customer', { state: { mode: 'edit', customer } })
  }

  const onPressDeactivate = (customer: Customer) => {
    setSelectedCustomer(customer);
    setDeactivateModal(true);
  };


  const onConfirmDeactivate = () => {
    const api_data = {
      ...selectedCustomer,
      isActive: selectedCustomer?.isActive ? false : true,
      updatedBy: user?.userId,
    };

    dispatch(
      updateCustomer(api_data, () => {
        setDeactivateModal(false);
        onPageChange(1);
      }),
    );
  };

  const onSearch = (val: string) => {
    setSearch(val)
    debounceTimer.current = setTimeout(() => {
      dispatch(getCustomers({ pageSize, pageNumber: page, search: val }));
    }, 500);
  }

  return {
    selectedCustomer,
    handleCreate,
    handleEdit,
    deactivateModal,
    setDeactivateModal,
    customers,
    onPageChange,
    page,
    onPressDeactivate,
    onConfirmDeactivate,
    customer_loading,
    search,
    onSearch
  };
};
